import api from './api'
import type { UserRole } from '@/utils/pagePermissions'

export interface AuthorizedUser {
  id: number
  email: string
  is_active: boolean
  role: UserRole
}

export interface AuthorizedUsersResponse {
  users: AuthorizedUser[]
  total: number
}

export async function getAuthorizedUsers(): Promise<AuthorizedUsersResponse> {
  const response = await api.get<AuthorizedUsersResponse>('/authorized-users')
  return response.data
}

export async function addAuthorizedUser(
  email: string,
  role: UserRole = 'user',
): Promise<AuthorizedUser> {
  const response = await api.post<AuthorizedUser>('/authorized-users', { email, role })
  return response.data
}

export async function updateAuthorizedUser(
  userId: number,
  data: { role?: UserRole; is_active?: boolean },
): Promise<AuthorizedUser> {
  const response = await api.patch<AuthorizedUser>(`/authorized-users/${userId}`, data)
  return response.data
}

export async function removeAuthorizedUser(userId: number): Promise<void> {
  await api.delete(`/authorized-users/${userId}`)
}

export interface AuthorizedUserReinviteResponse {
  ok: boolean
  email: string
}

export async function reinviteAuthorizedUser(
  userId: number,
): Promise<AuthorizedUserReinviteResponse> {
  const response = await api.post<AuthorizedUserReinviteResponse>(
    `/authorized-users/${userId}/reinvite`,
  )
  return response.data
}
